/* AFS7 - vaste afrekenbalk onderin het uitschuifmandje (V16: visuele versie).

   Waarom
   ------
   In de lade stond de Checkout-knop onderaan de samenvatting: op een iPhone op
   1.522px bij 775px zicht (12 okt 2026). Vanaf de startpagina ging 13% van de
   mandjes door naar de checkout, op de oude productpagina 44%. V15 zette een
   vaste balk neer; V16 maakt hem visueler op verzoek van de eigenaar: drie
   pictogrammen (cadeau, garantie, kortingscode), een slotje op de knop en de
   betaallogo's met "+ more".

   Hoe
   ---
   De opmaak staat in <template id="afs7-foot-tpl"> in sections/afs7-checkout-bar.liquid,
   zodat de teksten via de thema-editor lopen en de betaallogo's server-side met
   payment_type_svg_tag worden getekend. Dit script kloont die template in het
   bestaande paneel (.afs7-dw__panel) en vult alleen bedrag, cadeau en abonnement.
   afs7-drawer.js en de cartsectie zijn NIET aangepast. De knop drukt op de ECHTE
   afrekenknop (requestSubmit met die knop als submitter).

   De knop in de samenvatting verdwijnt pas als de balk staat (klasse has-foot
   op het paneel). Faalt dit script, dan blijft alles zoals het was.

   Valkuilen
   ---------
   - De lade vult zichzelf met innerHTML en cartfix vervangt de sectie na elke
     wijziging: daarom een MutationObserver op de body van de lade.
   - Lees het bedrag van de echte knop ("Checkout · €75,00"): die rekent het thema
     al goed uit in de valuta van de klant. Niets zelf omrekenen.
   - Shopify wil de abonnementstoestemming bij de afrekenknop. De volledige tekst
     blijft in de samenvatting; de balk noemt het kort en springt erheen.
   - Het kortingscode-vak is bewust een vraag ("Have a code?"): een stelling als
     "Discount code at checkout" las als korting voor iedereen. */
(function () {
  'use strict';
  if (window.__afs7Foot) return;
  window.__afs7Foot = true;

  var T = window.__afs7FootText || {};
  var panel, body, foot, els = {}, timer, seq = 0, lastGifts = 0;

  function q(s, r) { return (r || document).querySelector(s); }

  function make() {
    var tpl = document.getElementById('afs7-foot-tpl');
    if (!tpl) return false;
    foot = tpl.content.firstElementChild.cloneNode(true);
    els.amt = q('[data-f-amt]', foot);
    els.gift = q('[data-f-gift]', foot);
    els.gt = q('[data-f-gt]', foot);
    els.sub = q('[data-f-sub]', foot);
    els.terms = q('[data-f-terms]', foot);
    els.btn = q('[data-f-btn]', foot);
    els.btn.addEventListener('click', checkout);
    if (els.terms) els.terms.addEventListener('click', function () {
      var c = body && q('#shopify-buyer-consent, .afs7-consent, .afs2k-sum', body);
      if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    panel.appendChild(foot);
    return true;
  }

  function realButton() { return body && q('[name="checkout"]', body); }

  function checkout() {
    var b = realButton();
    if (!b) { window.location.href = '/checkout'; return; }
    els.btn.disabled = true;
    els.btn.classList.add('is-busy');
    var f = b.form || (b.getAttribute('form') && document.getElementById(b.getAttribute('form')));
    try {
      if (f && f.requestSubmit) f.requestSubmit(b); else b.click();
    } catch (e) { b.click(); }
    // Mocht de navigatie niet doorgaan, dan de knop weer vrijgeven.
    setTimeout(function () { els.btn.disabled = false; els.btn.classList.remove('is-busy'); }, 6000);
  }

  function amountFrom(b) {
    var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
    var i = t.lastIndexOf('·');
    return i > -1 ? t.slice(i + 1).trim() : '';
  }

  /* V17: het cadeauvak staat er altijd, want elke order krijgt gratis vitamins. Eerst verdween het
     bij 0 getelde cadeaus, maar EasyGift zet de gratis fles pas een fractie later in het mandje,
     dus het vak knipperde of ontbrak. Alleen de tekst wisselt nog: 2+ flessen = gift2. */
  function setGift(n) {
    if (!els.gift) return;
    var t = n >= 2 ? (T.gift2 || T.gift1 || '') : (T.gift1 || '');
    els.gt.textContent = t;
    els.gift.hidden = !t;
  }

  /* Uit de lade zelf: snel, werkt altijd. Cadeauregels hebben geen aantal-knoppen. */
  function domGifts() {
    var n = 0;
    body.querySelectorAll('.afs2k-line').forEach(function (l) {
      var txt = l.textContent || '';
      if (/vitamin/i.test(txt) && !q('.afs2k-line__ctl input, .afs2k-line__ctl button', l) && /free/i.test(txt)) n++;
    });
    return n;
  }
  function domSub() { return !!q('#shopify-buyer-consent, .afs7-consent, .afs7-subtag', body); }
  function setSub(on) { if (els.sub) els.sub.hidden = !on; }

  function update() {
    if (!panel || !body || !foot) return;
    var b = realButton();
    if (!b) { foot.hidden = true; panel.classList.remove('has-foot'); return; }
    els.amt.textContent = amountFrom(b);
    // Tijdens het opnieuw opbouwen telt de lade soms tijdelijk minder cadeauregels; dan niet
    // terugspringen naar de lagere tekst. Alleen /cart.js mag het aantal verlagen.
    setGift(Math.max(domGifts(), lastGifts));
    setSub(domSub());
    foot.hidden = false;
    panel.classList.add('has-foot');

    // Nauwkeuriger uit /cart.js: echte aantallen en abonnementen.
    var my = ++seq;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || my !== seq || !c.items) return;
        var gifts = 0, hasSub = false;
        c.items.forEach(function (it) {
          if (it.selling_plan_allocation) hasSub = true;
          if (it.final_line_price === 0 && /vitamin/i.test(it.product_title || '')) gifts += it.quantity;
        });
        lastGifts = gifts;
        setGift(gifts);
        setSub(hasSub);
      })
      .catch(function () {});
  }

  function soon() { clearTimeout(timer); timer = setTimeout(update, 120); }

  function attach() {
    panel = q('.afs7-dw__panel');
    body = panel && q('.afs7-dw__body', panel);
    if (!panel || !body) return false;
    if (!make()) return true; // geen template: niets doen, lade blijft zoals hij was
    new MutationObserver(soon).observe(body, { childList: true, subtree: true });
    var root = panel.closest('.afs7-dw');
    if (root) new MutationObserver(soon).observe(root, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('afs7:drawer-filled', soon);
    update();
    return true;
  }

  // De lade wordt door afs7-drawer.js gebouwd; wacht tot hij er is.
  function wait(tries) {
    if (attach()) return;
    if (tries > 0) setTimeout(function () { wait(tries - 1); }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wait(80); }, { once: true });
  } else { wait(80); }
})();
